const state = {
    IsLogin: false, // 是否登录状态(true：已登录 false：未登录)
    OmsLogo: null, // 运营平台Logo
    Logo: null, // 运营平台Logo
    UserInfo: null, // 用户信息
    Auths: null, // 权限菜单
    AuthsMenu: null, // 权限菜单
    Menu: null, // 侧边栏菜单
    CompanyInfo: null, // 公司信息
    PageTitle: '运营平台', // 页面Title
    nowSystemTime: '',
    subItemUrls: []
}

export default state;